var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z",
    fill: "#E2F4EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 -8.30516e-07C29.4934 -1.2892e-06 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 -3.71835e-07 29.4934 -8.30516e-07 19C-1.2892e-06 8.50659 8.50659 -3.71835e-07 19 -8.30516e-07ZM19 36.1C28.4441 36.1 36.1 28.4441 36.1 19C36.1 9.55593 28.4441 1.9 19 1.9C9.55593 1.9 1.9 9.55593 1.9 19C1.9 28.4441 9.55593 36.1 19 36.1Z",
    fill: "#21B17D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.9062L17.0773 23L17.0574 22.98L24 16",
    stroke: "#00834F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCircle);
export default __webpack_public_path__ + "static/media/ProgressCircle.7ede203462ecbcd769dcf475e7905097.svg";
export { ForwardRef as ReactComponent };